import { defineMessages, IntlShape } from "react-intl";

import ReportType from "@app/enum/ReportType";

const headerMessages = defineMessages({
  [ReportType.ACTIVITY]: {
    id: "reports.activity",
    defaultMessage: "Activity",
    description: "Activity header",
  },
  [ReportType.ALL_DASHBOARDS]: {
    id: "reports.cumul.allDashboards",
    defaultMessage: "All Dashboards",
    description: "All Dashboards",
  },

  [ReportType.COMPANIES]: {
    id: "reports.companies",
    defaultMessage: "Companies",
    description: "companies header",
  },
  [ReportType.DEALS]: {
    id: "reports.deals",
    defaultMessage: "Deals",
    description: "Deals header",
  },
  [ReportType.DEALS_BY_GEOGRAPHY]: {
    id: "reports.dealsBYGeography",
    defaultMessage: "Deals by Geography",
    description: "Deals by geography header",
  },
  [ReportType.EXPORT_EDIT]: {
    id: "reports.editExports",
    defaultMessage: "Edit Export",
    description: "Edit export header",
  },
  [ReportType.EXPORTS]: {
    id: "reports.exports",
    defaultMessage: "Exports",
    description: "Exports header",
  },
  [ReportType.LEADERBOARD]: {
    id: "reports.leaderboard",
    defaultMessage: "Stack Rank",
    description: "Leaderboard header",
  },
  [ReportType.MILEAGE_TRACKING]: {
    id: "reports.mileageTracking",
    defaultMessage: "Mileage Tracker",
    description: "Mileage Tracking header",
  },
  [ReportType.OVERVIEW]: {
    id: "reports.overview",
    defaultMessage: "Overview",
    description: "Overview header",
  },
  [ReportType.PEOPLE]: {
    id: "reports.people",
    defaultMessage: "People",
    description: "People header",
  },
  [ReportType.PINNED_DASHBOARD]: {
    id: "reports.cumul.pinnedDashboard",
    defaultMessage: "Default Dashboard",
    description: "Pinned Dashboard",
  },
  [ReportType.REVENUE]: {
    id: "reports.revenue",
    defaultMessage: "Revenue",
    description: "Revenue header",
  },
  [ReportType.ROUTES]: {
    id: "reports.routes",
    defaultMessage: "Routes",
    description: "Routes header",
  },
  [ReportType.UPGRADE_YOUR_REPORTS]: {
    id: "reports.cumul.upgradeYourReports",
    defaultMessage: "Upgrade Your Reports",
    description: "Upgrade your reports",
  },
  [ReportType.WEEKLY_REPORT_CARD]: {
    id: "reports.weeklyReportCard",
    defaultMessage: "Weekly report card",
    description: "Weekly report header",
  },
});

const getReportsHeaderDisplayName = (intl: IntlShape, reportType: ReportType): string =>
  intl.formatMessage(headerMessages[reportType]);

export default getReportsHeaderDisplayName;
